import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CardinalityAlertComponent } from './cardinality-alert.component';

const routes: Routes = [
    {
    path: '',
    component: CardinalityAlertComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class CardinalityRoutingModule {}
